/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_Credits_HintInputs */

const cs_youtube_export_credits_hint = /** @type {(inputs: Youtube_Export_Credits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každé nahrání spotřebuje 10 AI kreditů. Videí můžete přidat více; každé se uloží jako odkaz níže.`)
};

const en_youtube_export_credits_hint = /** @type {(inputs: Youtube_Export_Credits_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each upload uses 10 AI credits. You can upload multiple videos; each appears as a media link below.`)
};

/**
* | output |
* | --- |
* | "Each upload uses 10 AI credits. You can upload multiple videos; each appears as a media link below." |
*
* @param {Youtube_Export_Credits_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_credits_hint = /** @type {((inputs?: Youtube_Export_Credits_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_Credits_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_credits_hint(inputs)
	return cs_youtube_export_credits_hint(inputs)
});